import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { getTempTutorChangeInfo } from '../../selectors/enrolmentManagementSelector';
import { isGroupEnrolment } from '../../selectors/hubSelector';
import { NextSession } from './NextSession';
import OnGoingSchedule from './OnGoingSchedule';
import SectionTitle from './SectionTitle';
import { ConnectedTempTutor as TempTutor } from './TempTutorChange/TempTutor';
import Tutor from './Tutor';

const ScheduleDetails = ({ isGroup, tutorInfo }) => {
  const {
    hasTempTutorChange,
    sessionsWithTempTutorChange,
    nextSessionTutorNumber,
    nextSessionDateWithCurrentTutor,
    nextSessionDateWithTempTutor,
  } = tutorInfo;
  return (
    <div className="mb-5 md:mb-10">
      <div className="flex flex-col rounded-lg border border-grey-2 bg-white lg:flex-row">
        <div className="flex-grow">
          <div className="px-5 py-6 md:p-10">
            <SectionTitle title={`${isGroup ? 'Group' : 'Private'} tutoring sessions`} />
            <OnGoingSchedule />
            <NextSession />
          </div>
        </div>
        <div className="border-l border-grey-2">
          {hasTempTutorChange ? (
            <TempTutor
              sessionsWithTempTutorChange={sessionsWithTempTutorChange}
              nextSessionTutorNumber={nextSessionTutorNumber}
              nextSessionDateWithTempTutor={nextSessionDateWithTempTutor}
              nextSessionDateWithCurrentTutor={nextSessionDateWithCurrentTutor}
            />
          ) : (
            <Tutor />
          )}
        </div>
      </div>
    </div>
  );
};

ScheduleDetails.propTypes = {
  isGroup: PropTypes.bool.isRequired,
  tutorInfo: PropTypes.shape({
    hasTempTutorChange: PropTypes.bool,
    enrolmentTutor: PropTypes.string,
    nextSessionTutor: PropTypes.string,
    nextSessionTutorNumber: PropTypes.string,
    nextSessionDateWithTempTutor: PropTypes.string,
    sessionsWithTempTutorChange: PropTypes.number,
    nextSessionDateWithCurrentTutor: PropTypes.string,
  }).isRequired,
};

export default connect((state) => {
  return {
    isGroup: isGroupEnrolment(state),
    tutorInfo: getTempTutorChangeInfo(state),
  };
}, null)(ScheduleDetails);
